<template>
    <div :class="`[ c-form-item c-form-item--fluid ] u-flex-set ${ customClass ? customClass : ''}`">
        <label :for="name" class="u-hidden-visually">{{label}}</label>
        <input v-model="term"
               @input="changed"
               type="text" class="[ c-input c-form-element ]"
               :disabled="disabled"
               :name="name"
               :id="name"
               :placeholder="placeholder">

        <a  v-if="term && !disabled"
            href="#close"
            @click.prevent="reset"
            class="c-input__close"
            title="Clear">

            <svgicon class="icon" name="close"></svgicon>
        </a>
    </div>
</template>

<script>
    import debounce from 'lodash/debounce'

    export default {
        props: ['name', 'label', 'placeholder', 'customClass', 'disabled'],
        data() {
            return {
                loading: true,
                term: ''
            }
        },
        methods: {
            changed() {
              this.$emit('update:term', this.term);
              this.$emit('changed');
            },
            reset() {
                this.term = '';
                this.changed();
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";

    .c-form-item {
        position: relative;
    }

    .c-input {
        min-width: 270px;

        &__close {
            position: absolute;
            padding: 7px;
            top: 1px;
            right: 5px;
            cursor: pointer;
            &:hover {
                opacity: 0.8;
            }
            .icon { color: #666; }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/form/filters/FilterInput.vue